import { createSelector } from '@reduxjs/toolkit';
import { selectOfferTypeOptions } from './selectOfferTypeOptions';
import { selectOfferType } from 'shared/selectors/jsonQuery';

export const selectOfferTypeValue = createSelector(
  [selectOfferTypeOptions, selectOfferType],
  (offerTypeOptions, currentOfferType) => {
    return offerTypeOptions
      .filter(offerType => (currentOfferType & offerType.value) !== 0)
      .map(offerType => offerType.value);
  },
);
